import ReportWrapper from '../ReportWrapper'
import React from 'react'
import RongdataLimitHighConsumptionCasesOverview from './RongdataLimitHighConsumptionCasesOverview'
import LimitHighConsumptionCase from './LimitHighConsumptionCase'
import ExpandableListWrapper from '../../../components/ExpandableListWrapper'
import { Stack, Text } from '@mantine/core'
import ReportSectionHeading from '../ReportSectionHeading'
import { useTheme } from '../../../components/ThemeProvider'

interface LimitHighConsumptionCasesProps {
  data: any
  title: string
  sectionIndex?: string
}

export default function RongdataLimitHighConsumptionCases({
  data,
  title,
  sectionIndex,
}: LimitHighConsumptionCasesProps) {
  const theme = useTheme()
  const cases = data?.limited_case_info ?? []
  const caseCount = cases.length

  return (
    <ReportWrapper>
      <ReportSectionHeading title={title} index={sectionIndex} />
      <RongdataLimitHighConsumptionCasesOverview data={data} />
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          限制高消费记录
        </Text>
        <Stack gap="sm" className="mt-3">
          <ExpandableListWrapper isEmpty={caseCount === 0}>
            {cases.map((item: any, index: number) => (
              <LimitHighConsumptionCase key={index} number={index + 1} item={item} />
            ))}
          </ExpandableListWrapper>
        </Stack>
      </div>
    </ReportWrapper>
  )
}
